import { FC } from 'react'
import {
    NOT_AVAILABLE,
    statusLabelMap,
    statusLabelMapServiceRequests,
} from '@/ui/components/cases-table/CasesTable.utils'
import Typography from '@/ui/components/typography'
import { Badge } from './HeaderStatusBadge.styles'
import { HeaderStatusBadgeProps } from './HeaderStatusBadge.types'

const HeaderStatusBadge: FC<HeaderStatusBadgeProps> = ({
    status,
    variant = 'incident',
    className,
    testId,
}) => {
    const labelMap =
        variant === 'serviceRequest'
            ? statusLabelMapServiceRequests
            : statusLabelMap

    return (
        <Badge
            status={status}
            className={className}
            data-testid={testId ?? `header-status-${status}`}
        >
            <Typography variant="s-regular" color="inherit">
                {labelMap[status] ?? NOT_AVAILABLE}
            </Typography>
        </Badge>
    )
}

export default HeaderStatusBadge
